// extracted by mini-css-extract-plugin
export default {"inputPopup":"TextAreaComponent_inputPopup__N-fRB","chat":"TextAreaComponent_chat__QL3Bn"};